var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0015 1.48071L22.7428 12.768L22.757 12.7842C22.7748 12.8047 22.8058 12.8413 22.8386 12.8892C22.8647 12.9273 22.9324 13.0294 22.9766 13.1764C23.0234 13.3323 23.0733 13.6505 22.8798 13.9783C22.6993 14.2841 22.4256 14.392 22.3148 14.4269C22.1959 14.4645 22.097 14.471 22.0638 14.473C22.0214 14.4755 21.9868 14.4749 21.9749 14.4747L21.9568 14.4743L21.9514 14.4742H20.0241V23.4556H14.0177V17.4632H10.0351V23.4805H4.00167V14.4597H2.08237C1.14974 14.4597 0.703507 13.3777 1.27199 12.7076L1.2912 12.6849L12.0015 1.48071ZM4.27331 12.4597H6.00167V21.4805H8.03506V15.4632H16.0177V21.4556H18.0241V12.4742H19.7023L11.9982 4.37849L4.27331 12.4597Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.99ac6970.svg";
export { ForwardRef as ReactComponent };